import React, { useState } from 'react';
import {
    createStyles,
    ActionIcon,
    Stack,
    Title,
    Group,
    Progress,
    Card,
    Flex,
    Modal,
    RingProgress,
    Text
} from '@mantine/core';
import {
    IconGavel,
    IconArticle,
    IconPhotoEdit,
    IconDeviceFloppy,
    IconArrowBigRight,
    IconX,
    IconChevronsDown,
    IconEdit,
    IconPencil,
} from '@tabler/icons';
import { useDispatch, useSelector } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
import { 
    testGalleryUpdated,
    selectAllTestData,
    selectIntroGallery,
    carCreatorSelectSectionDataB
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';

//below is the line where we import items from different slices
//import {}
import { CarCreationCardA } from '../components/CarCreationCardA';
import { CarCreationCardB } from '../components/CarCreationCardB';
import { CarCreationCardC } from '../components/CarCreationCardC';
import { CarComponent } from '../components/CarComponent';
import { CarCardDets } from '../components/CarCardDets';

import { CommentCreationCard } from '../components/CommentCreationCard';
import { CommentCard } from '../components/CommentCard';
import { BidsCommentsTabNav } from '../components/BidsCommentsTabNav';
import { CarCardDetsBids } from '../components/CarCardDetsBids';
import { CarCardDetsTable } from '../components/CarCardDetsTable';
import { MultiMediaGallery } from '../components/MultiMediaGallery';
import { CanvasCardBase } from '../components/CanvasCardBase';
import ConfirmationCardBase from '../components/ConfirmationCardBase';
import PlaceBid from '../components/PlaceBid';
import { VideoPlayerCard } from '../components/VideoPlayerCard';
import { AlertMeCard } from '../components/AlertMeCard';
import { SchedulerCard } from '../components/SchedulerCard';
import BizMgmtEdit from '../components/BizMgmtEdit';
import AccntMgmtEdit from '../components/AccntMgmtEdit';


//default assets
import crypto_symbols from '../assets/crypto_symbols.jpg';
import koenigsegg from '../assets/koenigsegg.jpg';
import pagani from '../assets/pagani.jpg';




const useStyles = createStyles((theme) => ({
    cardStyle: {
        width: '80%',
    },
    leftCardSection: {
        marginLeft: '0%'
    },
    
}));

//needed:ability to opt-out of sections article
//needed:copy to a 'components' page for erik to see
export function AppComponentsDev (){
    const { classes } = useStyles();
    const dispatch = useDispatch();
    /*
     *:AREA:  dispatch actions 
     * - save section
     * - saveChange(for all sections)
     * - calculatePercentCall
     * - pushMedia
     * - completeUpload
     * - verificationChecks on auction item
     * :AREA: calls to ref db
     * - carMake and carModel
     * - 
     * 
    */

    //of_note:need useSelectors and dispatch events to update the flow in real
    //keeping track of form completion
    //also necessary we need to repopulate the fields after the section has been closed(if not the first time for this listing)
    const [detsOpened, setDetsOpened] = useState(false);
    const [sectionAPercComp, setSectionAPercComp] = useState(0);
    const [stepBOpened, setStepBOpened] = useState(false);
    const [sectionBPercComp, setSectionBPercComp] = useState(0);
    const [stepCOpened, setStepCOpened] = useState(false);
    const [sectionCPercComp, setSectionCPercComp] = useState(0);
    //below here should be placed
    const [stepDOpened, setStepDOpened] = useState(false);
    const [stepEOpened, setStepEOpened] = useState(false);
    const [stepFOpened, setStepFOpened] = useState(false);
    const [stepGOpened, setStepGOpened] = useState(false);
    const [stepHOpened, setStepHOpened] = useState(false);
    const [stepIOpened, setStepIOpened] = useState(false);
    const [stepJOpened, setStepJOpened] = useState(false);

    const [stepKOpened, setStepKOpened] = useState(false);
    const [stepLOpened, setStepLOpened] = useState(false);

    //descript:old but kept for reference 
    const testImages = useSelector(selectIntroGallery);
    let authHold = {
        src: koenigsegg,
        name: "John Does"
    }
    function handleClick(e){
        console.log('hit the click');
        console.log(window.history);
        window.history.forward()
    }
    
    
    return(
        <>
            <Stack
                align="center"
                justify="space-around"
            >
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack
                                className={classes.marginLeft}
                                align="center"
                                justify="center"
                                name="details_contain"
                                onClick={() => setDetsOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconGavel size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Details
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>

                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack
                                className={classes.marginLeft}
                                align="center"
                                justify="center"
                                name="article_contain"
                                onClick={() => setStepBOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconArticle size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Article
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>

                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack
                                className={classes.marginLeft}
                                align="center"
                                justify="center"
                                name="media_contain"
                                onClick={() => setStepCOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Media
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                
                
                
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepDOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    MediaGallery
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepEOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Zoom And Pan
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepFOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Confirmation
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepGOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Video Player
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepHOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    AlertMe
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepIOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Scheduler
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
    
                            />
                        </Group>
                    </Card.Section>
                </Card>
                
                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepJOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPhotoEdit size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    PlaceBid
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
                            />
                        </Group>
                    </Card.Section>
                </Card>
                

                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepKOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPencil size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Accnt Mgmt
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
                            />
                        </Group>
                    </Card.Section>
                </Card>
                

                <Card
                    className={classes.cardStyle}
                    shadow="sm"
                    p="lg"
                    radius="md"
                    withBorder
                >
                    <Card.Section>
                        <Group position="center" spacing="xl">
                            <Stack className={classes.marginLeft} align="center" justify="center"
                                onClick={() => setStepLOpened(true)}
                            >
                                <ActionIcon
                                    radius="lg"
                                    size="xl"
                                    variant="transparent"
                                    color="dark"
                                >
                                    <IconPencil size={36} stroke={2.0}/>
                                </ActionIcon>
                                <Text td="underline" fz="xl">
                                    Business Management
                                </Text>
                            </Stack>
                            <RingProgress label={
                                <Text size="md" align="center">
                                    0%
                                </Text>
                            }
                            sections={[
                                { value: 0, color: 'green' },
                                { value: 100, color: 'grey' },
                            ]}
                            />
                        </Group>
                    </Card.Section>
                </Card>
                

            </Stack>
            <br/>
            <br/>
            <br/>
            <Group position="center" spacing="xl">
                {/*do we need this Group*/}
                <ActionIcon
                    name="save_draft"
                    radius="lg"
                    size="xl"
                    variant="filled"
                    color="blue"
                >
                    <IconDeviceFloppy id="saveDraft" size={36} stroke={2.0}/>
                </ActionIcon>
                <ActionIcon
                    name="cancel"
                    radius="lg"
                    size="xl"
                    variant="filled"
                    color="red"
                >
                    <IconX id="cancelListing" size={36} stroke={2.0}/>
                </ActionIcon>
                <ActionIcon
                    name="preview"
                    radius="lg"
                    size="xl"
                    variant="filled"
                    color="green"
                >
                    <IconArrowBigRight id="nextStep" size={36} stroke={2.0}/>
                </ActionIcon>
            </Group>
            
            
            <Modal
                opened={detsOpened}
                withFocusReturn={true}
                onClose={() => setDetsOpened(false)}
                overflow="inside"
            >
                <CarCreationCardA/>
                
            </Modal>
            <Modal
                overflow="inside"
                withFocusReturn={true}
                opened={stepBOpened}
                onClose={() => setStepBOpened(false)}
            >
                <CarCreationCardB />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepCOpened}
                onClose={() => setStepCOpened(false)}
            >
                <CarCreationCardC />
            </Modal>
            
            
            
            
            <Modal
                withFocusReturn={true}
                opened={stepDOpened}
                onClose={() => setStepDOpened(false)}
            >
                <MultiMediaGallery />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepEOpened}
                onClose={() => setStepEOpened(false)}
            >
                <CanvasCardBase text="a Test you know" />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepFOpened}
                onClose={() => setStepFOpened(false)}
            >
                <ConfirmationCardBase message={"Place bid of $1,500,000 on Pagani Huarya?"} />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepGOpened}
                onClose={() => setStepGOpened(false)}
            >
                <VideoPlayerCard />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepHOpened}
                onClose={() => setStepHOpened(false)}
            >
                <AlertMeCard />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepIOpened}
                onClose={() => setStepIOpened(false)}
            >
                <SchedulerCard />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepJOpened}
                onClose={() => setStepJOpened(false)}
            >
                <PlaceBid message={"Your bid must be greater than $000,000"} />
            </Modal>

            <Modal
                withFocusReturn={true}
                opened={stepKOpened}
                onClose={() => setStepKOpened(false)}
                title="Account Management"
            >
                <AccntMgmtEdit />
            </Modal>
            <Modal
                withFocusReturn={true}
                opened={stepLOpened}
                onClose={() => setStepLOpened(false)}
                title="Business Info"
            >
                <BizMgmtEdit />
            </Modal>
        </>
    )
}
